<template>
  <li class="boss-jobtype-item margin-bottom-05">
    <div class="boss-label display-flex">
      <template v-if="canAccordion">
        <span
          v-if="!showCategoryItems"
          data-test="open-category"
          class="pega-modal-accordion"
          @click="switchShowCategory"
        >+</span>
        <span
          v-else
          data-test="close-category"
          class="pega-modal-accordion"
          @click="switchShowCategory"
        >–</span>
      </template>
      <label class="pega-input">
        <input
          v-model="all"
          type="checkbox"
          class="boss-input-check"
        >{{ category.name }}
      </label>
    </div>
    <ul
      v-show="showCategoryItems || !canAccordion"
      data-test="category-items"
      class="boss-jobtype-details"
    >
      <select-modal-contents-category-item
        v-for="(categoryItem, index) in category.children"
        :key="index"
        :category-item="categoryItem"
        :category-item-data-map="categoryDataMap[categoryItem.id]"
        :experience-range-options="experienceRangeOptions"
        :default-experience-id="defaultExperienceId"
        @update-category-item="updateCategoryItem"
      />
    </ul>
  </li>
</template>

<script>
import SelectModalContentsCategoryItem from '@/components/molecules/SelectModalContentsCategoryItem'

export default {
  components: {
    SelectModalContentsCategoryItem
  },
  props: {
    category: {
      type: Object,
      required: true
    },
    categoryDataMap: {
      type: Object,
      required: true
    },
    experienceRangeOptions: {
      type: Array,
      default: () => ([])
    },
    defaultExperienceId: {
      type: String,
      default: ''
    },
    canAccordion: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showCategoryItems: false
    }
  },
  computed: {
    all: {
      get () {
        return this.category.children.every(j => this.categoryDataMap[j.id].check)
      },
      set (value) {
        this.updateCategoryChecks(value)
      }
    }
  },
  methods: {
    switchShowCategory () {
      this.$set(this, 'showCategoryItems', !this.showCategoryItems)
    },
    updateCategoryItem (data) {
      this.$emit('update-category', { id: this.category.id, value: { ...this.categoryDataMap, [data.id]: data.value } })
    },
    updateCategoryChecks (value) {
      // data[CategoriesId][categoryId]のcheckを全て置き換える
      this.$emit('update-category', {
        id: this.category.id,
        value: this.category.children.reduce((acc, currentChildCategory) => (
          { ...acc, [currentChildCategory.id]: { ...this.categoryDataMap[currentChildCategory.id], check: value } }
        ), {})
      })
    }
  }
}
</script>
